import styled from 'styled-components';

export const ResourceOnboardingSequenceStepInformationContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > :not(:last-child) {
    margin-bottom: 20px;
  }

  z-index: 3;
`;

export const ResourceOnboardingSequenceStepCounter = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  color: rgba(23, 28, 51, 0.5);
`;

export const ResourceOnboardingSequenceStepTitle = styled.h6`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: var(--color-text);
`;

export const ResourceOnboardingSequenceButton = styled.div`
  position: absolute;
  top: -5px;
  right: 12px;

  z-index: 3 !important;

  &:before {
    content: '';
    width: 21px;
    height: 23px;
    border-radius: 100%;

    position: absolute;

    backdrop-filter: blur(16px);
    transform: translateX(1px);

    z-index: 0;
  }

  cursor: pointer;
`;
